import * as Converter from "./converter";

import type * as Type from "./type";
import type * as Repository from "../../_repository";

type Props = {
	viewModel: Type.ViewModel;
	// オプションカラーリスト
	optionPmsColorListQueryData: Repository.Query.QueryData.OptionPmsColorListQueryData;
	// オプションリスト
	optionPmsActiveListQueryData: Repository.Query.QueryData.OptionPmsList.OptionPmsActiveListQueryData;
};
type Result = {
	viewData: Type.ViewData;
};

export const useViewData = ({
	viewModel,
	optionPmsColorListQueryData,
	optionPmsActiveListQueryData,
}: Props): Result => {
	const { viewData } = Converter.useViewDataConverter({
		optionPmsColorListQueryData,
		optionPmsActiveListQueryData,
		viewModel,
	});

	return {
		viewData,
	};
};
